import { render, staticRenderFns } from "./Multiposting.vue?vue&type=template&id=65266774"
import script from "./Multiposting.vue?vue&type=script&lang=ts"
export * from "./Multiposting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports